<template>
  <div v-if="scoreToBeShown.length > 0">
    <div class="title mb-3">CURRICULUM</div>
    <b-container class="mt-4"
                 v-show="availablePhases.length > 1 || availableSessions.length > 1">
      <b-row class="header text-center">
        <b-col><!--***-->Fase</b-col>
        <b-col><!--***-->Sessione</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <combo-or-label v-model="phase" :options="availablePhases"></combo-or-label>
        </b-col>
        <b-col>
          <combo-or-label v-model="session" :options="availableSessions"></combo-or-label>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <template v-for="round in scoreToBeShown">
        <b-row class="mt-3 currHeader mb-3">
          <b-col>
            R.{{ round.round }}
          </b-col>
          <b-col cols="10"
                 v-html="getOppositeName(round)">
          </b-col>
        </b-row>
        <template v-for="board in getScores(round)">
          <b-form-row class="mb-2 curriculumRow">
            <b-col cols="1">
              {{ board.BoardNumber }}
            </b-col>
            <b-col cols="4" class="boardResult">
              <b-spinner v-if="board.Alter === -1" small variant="success"></b-spinner>
              <template v-else>
                <k-progress v-if="board.PercNs != null"
                            :percent="Math.round(board.NSex === pairId ? board.PercNs : board.PercEw)"
                            :color="val => formatColor(val/100)"></k-progress>
                <div v-else v-text="board.NSex === pairId ? board.PuntiNs : board.PuntiEw"
                     :class="['font-weight-bold', computeScoreColor(board, pairId)]"></div>
              </template>
            </b-col>
            <b-col cols="3">
              <div v-html="addColorToSuite(board.TextualContract)"></div>
            </b-col>
            <b-col cols="2">
              <div v-html="addColorToSuite(board.TextualLead)"></div>
            </b-col>
            <b-col cols="2" class="text-right">
              {{ board.TextualScore }}
            </b-col>
          </b-form-row>
        </template>
      </template>
    </b-container>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import chroma from 'chroma-js';
import ComboOrLabel from "../components/lib/ComboOrLabel";
import {addColorToSuite as _addColorToSuite} from "../lib/cardSuits";

export default {
  name: 'Curriculum',
  components: {ComboOrLabel},
  data() {
    return {
      formatColor: chroma.scale(['red', 'yellow', 'green']),
      phase: 1,
      session: 1
    };
  },
  computed: {
    ...mapGetters({
      playerContestHistoryMap: 'players/playerContestHistoryMap',
      globalDeals: 'deals/played',
      pairId: 'tournament/pairId',
      pairsList: 'players/pairsList',
      played: 'deals/played'
    }),
    availablePhases() {
      return [...new Set(Object.values(this.playerContestHistoryMap).map(s => s.phase).sort((a, b) => a - b))];
    },
    availableSessions() {
      return [...new Set(this.playerContestHistoryMap.filter(ris => this.phase === ris.phase).map(ris => ris.session).sort((a, b) => a - b))];
    },
    scoreToBeShown() {
      return this.playerContestHistoryMap
          .filter(ris => this.phase === ris.phase)
          .filter(ris => this.session === ris.session)
          .sort((a, b) => a.round - b.round);
    }
  },
  methods: {
    computeScoreColor(result, pairId) {
      const points = result.NsEventId === pairId ? result.PuntiNs : result.PuntiEw;
      const intPoints = parseInt(points);
      return intPoints > 0 ? "greenResult" : intPoints < 0 ? "redResult" : "yellowResult";
    },
    addColorToSuite(contract) {
      return _addColorToSuite(contract);
    },
    getOppositeName(score) {
      return score.NsEventId === this.pairId ? this.pairsList[score.EwEventId].Name : this.pairsList[score.NsEventId].Name;
    },
    getScores(score) {
      const that = this;
      return score.PlayedBoards.flatMap(brdNumber => that.globalDeals
          ?.Phases[score.phase]
          ?.Sessions[score.session]
          ?.Ranksets[score.rankset]
          ?.Boards[brdNumber]
          ?.Scores
          ?.filter(score => [score.NSex, score.EWex].includes(that.pairId)) ?? null
      ).filter(el => el !== null)
    }
  }
}
;
</script>

<style scoped>
.currHeader {
  background-color: #C7DDE5;
}

>>> .k-progress {
  margin: 0 !important;
}

.curriculumRow {
  line-height: 20px;
}


.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}
</style>
